import React from 'react'
import styles from './ActionButtons.module.scss'
import clsx from 'clsx'
import {FADE_IN_ANIMATION_DELAYS} from '../../constants'
import {FadeInContainer} from '../../../../common/FadeInContainer'
import {ShareButton} from './ShareButton'
import {MapReplayButton} from './MapReplayButton'

export function ActionButtons({disableAnimation}: {disableAnimation: boolean}) {
    return (
        <FadeInContainer
            animationDelayMs={FADE_IN_ANIMATION_DELAYS.topLeftButtons}
            animationDurationMs={FADE_IN_ANIMATION_DELAYS.transitionDuration}
            className={clsx(styles.buttonsContainer)}
            disableAnimation={disableAnimation}>
            <div className={styles.buttonsWrapper}>
                <MapReplayButton />
                <ShareButton />
            </div>
        </FadeInContainer>
    )
}
